var domain = "https://europe-west1-vhenga-site.cloudfunctions.net/appeu";

// if (window.location.origin == "http://localhost:3000") domain = "http://localhost:5001/vhenga-site/europe-west1/appeu";

export { domain };